import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";


export interface UserData {
    user_id: string;
    project_role_type_code: string;
    user_role_type_code: string;
    user_status_code: string;
    alias: string;
    email: string;
    fullname: string;
    phone_number: string;
    company_name: string;
    department_name: string;
    department_rank: string;
    sms_notify_yn: boolean;
    email_notify_yn: boolean;
    language: string;
    create_ts: string;
    update_ts: string;
}

export interface RdsClientDeviceData {
    rds_client_device_id: string;
    device_name: string;
    device_os_name: string;
    device_serial_number: string;
    processor_spec: string;
    memory_spec: string;
    graphic_spec: string;
    physical_spec: string;
    client_version: string;
    license_activate_yn: boolean;
    last_login_ts: string;
    current_login_ts: string;
    last_session_ts: string;
    activate_ts: string;
    deactivate_ts: string;
    verify_ts: string;
    public_ip_address: string;
    private_ip_addresses: string;
    license_id: string;
    license_name: string;
    license_number: string;

    user: UserData
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SERVICE_LICENSE_DEACTIVATE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "DEVICE_DEACTIVATE",
        },
    },
];


export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_DEVICE_PHYSICAL_SPEC_TEXT"),
        accessor: "physical_spec",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_DEVICE_OS_NAME_TEXT"),
        accessor: "device_os_name",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#5c5c5c"}}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_DEVICE_PROCESSOR_SPEC"),
        accessor: "processor_spec",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_DEVICE_SERIAL_NUMBER_TEXT"),
        accessor: "device_serial_number",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_RDS_CLIENT_DEVICE_CLIENT_VERSION_TEXT"),
        accessor: "client_version",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#3a8344"}}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_ACTIVATE_DATE_TEXT"),
        accessor: "activate_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("SERVICE_DEACTIVATE_DATE_TEXT"),
        accessor: "deactivate_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("SERVICE_VERIFY_DATE_TEXT"),
        accessor: "verify_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    }
];


const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    greenText: {
        color: "#3a8344"
    }
}